import { useEffect, useState } from "react"
import { makeStyles } from "tss-react/mui"
import { SelectChangeEvent } from "@mui/material"
import { useSearchParams } from "react-router-dom"
import { MenuItem, Select, FormControl } from "@mui/material"
import { DashboardDataCard, DashboardDataContents } from "../../../../../dashboards/components/DashboardDataCard"
import { LocalizedEnum, LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { StatisticsPosNumberOfTransactions } from "./StatisticsPosNumberOfTransactions"
import { DashboardCardGroup } from "../../../../../dashboards/components/Dashboard"
import { StatisticsNumberOfUsersContent } from "./StatisticsNumberOfUsers"
import { StatisticsPieChartCheckIns } from "./StatisticsPieChartCheckIns"
import { StatisticsPosSales } from "./StatisticsPosSales"
import { SurveySummaries } from "./SurveySummaries"

const useStyles = makeStyles()(() => ({
    select: {
        "&:after, &:before": {
            display: "none",
        },
    },
}))

const STATISTICS_PERIOD_QUERY_PARAM = "statisticsPeriod"
const PERIODS = [3, 14, 30, 60, 180]

export function Statistics() {
    const { classes } = useStyles()
    const [searchParams, setSearchParams] = useSearchParams()
    const [currencyPosSales, setCurrencyPosSales] = useState("")
    const queryStatisticsPeriod = searchParams.get(STATISTICS_PERIOD_QUERY_PARAM)

    const [periodInDays, setPeriodInDays] = useState<number>(queryStatisticsPeriod ? +queryStatisticsPeriod : 30)

    useEffect(() => {
        !!queryStatisticsPeriod && setPeriodInDays(+queryStatisticsPeriod)
    }, [])

    const handlePeriodChange = (event: SelectChangeEvent<number>) => {
        const newPeriod = Number(event.target.value)
        setPeriodInDays(newPeriod)
        searchParams.set(STATISTICS_PERIOD_QUERY_PARAM, newPeriod.toString())
        setSearchParams(searchParams)
    }

    return (
        <>
            <LocalizedStrict id="merchant-home-statistics-card-group" attrs={{ title: true }}>
                <DashboardCardGroup
                    title="Statistics"
                    titleRightContent={
                        <FormControl variant="standard" size="small">
                            <Select value={periodInDays} onChange={handlePeriodChange} className={classes.select}>
                                {PERIODS.map((option) => (
                                    <MenuItem key={option} value={option}>
                                        <LocalizedEnum
                                            base="merchant-home-statistics-period-base"
                                            enumValue={option.toString()}
                                        >
                                            <>{option}</>
                                        </LocalizedEnum>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    }
                >
                    <StatisticsPieChartCheckIns periodInDays={periodInDays} />
                    <LocalizedStrict
                        id="merchant-home-statistics-pos-turnover-card"
                        attrs={{ title: true, titleTooltip: true }}
                    >
                        <DashboardDataCard
                            title="POS turnover"
                            subtitle={currencyPosSales}
                            titleTooltip="POS turnover tooltip"
                            isHeighNormal={false}
                        >
                            <DashboardDataContents>
                                <StatisticsPosSales
                                    periodInDays={periodInDays}
                                    setCurrencyPosSales={setCurrencyPosSales}
                                />
                            </DashboardDataContents>
                        </DashboardDataCard>
                    </LocalizedStrict>
                    <LocalizedStrict id="merchant-home-statistics-pos-orders-card" attrs={{ title: true, titleTooltip: true }}>
                        <DashboardDataCard
                            title="POS orders"
                            titleTooltip="POS orders tooltip"
                            isHeighNormal={false}
                        >
                            <DashboardDataContents>
                                <StatisticsPosNumberOfTransactions periodInDays={periodInDays} />
                            </DashboardDataContents>
                        </DashboardDataCard>
                    </LocalizedStrict>
                    <LocalizedStrict
                        id="merchant-home-statistics-number-of-users-card"
                        attrs={{ title: true, titleTooltip: true }}
                    >
                        <DashboardDataCard
                            title="Number of users"
                            titleTooltip="Number of users tooltip"
                            isHeighNormal={false}
                        >
                            <DashboardDataContents>
                                <StatisticsNumberOfUsersContent periodInDays={periodInDays} />
                            </DashboardDataContents>
                        </DashboardDataCard>
                    </LocalizedStrict>
                    <SurveySummaries periodInDays={periodInDays} />
                </DashboardCardGroup>
            </LocalizedStrict>
        </>
    )
}
